export default "__VITE_ASSET__BIhmkH88__"